var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFirstSnowMain(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 53,
    viewBox: "0 0 43 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.7,
    cx: 13.5,
    cy: 12.5,
    r: 3.5,
    fill: "#4C95FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.7,
    cx: 21.5,
    cy: 25.5,
    r: 3.5,
    fill: "#4C95FF",
    fillOpacity: 0.1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.7,
    cx: 39.5,
    cy: 13.5,
    r: 3.5,
    fill: "#4C95FF",
    fillOpacity: 0.1
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.7,
    cx: 5.5,
    cy: 7.5,
    r: 3.5,
    fill: "#4C95FF",
    fillOpacity: 0.1
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.7,
    cx: 10.5,
    cy: 43.5,
    r: 3.5,
    fill: "#4C95FF",
    fillOpacity: 0.15
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 28.5,
    cy: 3.5,
    r: 3.5,
    fill: "#4C95FF"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 28.5,
    r: 3.5,
    fill: "#4C95FF"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 38.5,
    r: 3.5,
    fill: "#4C95FF"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 49.5,
    r: 3.5,
    fill: "#4C95FF"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 39.5,
    r: 3.5,
    fill: "#4C95FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstSnowMain);
export default __webpack_public_path__ + "static/media/firstSnow-main.91f10e84ad0d608aea19b6f344cd3e0d.svg";
export { ForwardRef as ReactComponent };